import { createFileRoute } from '@tanstack/react-router'
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";

function ForgotPassword() {
  return <ForgotPasswordForm />;
}

export const Route = createFileRoute('/(authentication)/(auth)/forgot-password/')({
  component: ForgotPassword,
})
